import { render } from "./detail.vue?vue&type=template&id=093822d8&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=093822d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-093822d8"

export default script